// Configure Quill modules and formats
export const quillModules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline', 'strike'], // toggled buttons
    ['blockquote', 'code-block'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
    [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
    [{ direction: 'rtl' }], // text direction
    [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
    [{ color: [] }, { background: [] }], // dropdown with defaults
    [{ font: [] }],
    [{ align: [] }],
    ['clean'], // remove formatting
    ['link', 'image'], // link and image
  ],
  clipboard: {
    // Toggle to add custom clipboard handling (not usually needed)
    matchVisual: false,
  },
};

export const quillFormats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
  'color',
  'background',
  'align',
  'script',
  'direction',
  'code-block',
];

// Define languages with their corresponding codes
const languageConfig = [
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'French' },
  { code: 'sl', label: 'Slovak' },
  { code: 'es', label: 'Estonian' },
  { code: 'lt', label: 'Latvian' },
  { code: 'ru', label: 'Russian' },
  { code: 'sp', label: 'Spanish' },
  { code: 'de', label: 'German' },
  { code: 'ca', label: 'Catalan' },
];

export const languages = languageConfig.map((lang) => lang.code);
export const visibleLanguages = languageConfig;

export function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
